import { ReactElement, ReactNode, useState, useEffect, useRef } from 'react'
import { DropdownContainer, DropdownButton, DropdownContent } from './Dropdown.styles'

type DropdownProps = {
  menuProp: ReactNode
  children: ReactElement
}

const Dropdown: React.FC<DropdownProps> = ({ menuProp, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownButton onClick={() => setIsOpen(!isOpen)}>{menuProp}</DropdownButton>
      <DropdownContent isMenuOpen={isOpen}>{children}</DropdownContent>
    </DropdownContainer>
  )
}

export default Dropdown
